import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentLinkService } from "../../../../services/document/document-link.service";
import { notification } from "antd";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateDocumentLink = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (vars: IVariable) => DocumentLinkService.updateDocumentLinkInfo(vars.id, vars.body),
  });

  const updateDocumentLink = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["document-link"],
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Xoá thất bại.`,
        });
      },
    });
  };

  return { updateDocumentLink, ...rest };
};
